import React, { SVGProps } from 'react';

const Error: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.0588 3.26606C12.2466 2.91131 12.7548 2.91131 12.9426 3.26606L21.9426 20.2661C22.1189 20.5991 21.8775 21 21.5007 21H3.50069C3.1239 21 2.8825 20.5991 3.05879 20.2661L12.0588 3.26606ZM12.5007 14C12.7768 14 13.0007 13.7761 13.0007 13.5V9.5C13.0007 9.22386 12.7768 9 12.5007 9C12.2245 9 12.0007 9.22386 12.0007 9.5V13.5C12.0007 13.7761 12.2245 14 12.5007 14ZM13.0007 17V16H12.0007V17H13.0007ZM20.6702 20H4.33114L12.5007 4.56863L20.6702 20Z" fill="#ED5D5D"/>
  </svg>
);

export default Error;
